import React from 'react'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import CarProduct from './CarProduct'
import HotelProduct from './HotelProduct'
import { Listing, CarListing, RudderProductDesc } from './types'

export function fireEventForViewMoreDeals() {
  analytics.fireEvent({
    action: 'Feature Box CTA',
    category: ANALYTICS_CATEGORY_HOME,
    label: 'Cross Sell View More Deals'
  })
}

function isCarListing(listing: Listing): listing is CarListing {
  return (listing as CarListing).carExample !== undefined
}

function renderXSellProduct(
  listing: Listing,
  position: number,
  offerId: string,
  offerToken: string,
  rudderParentProductCode: RudderProductDesc
) {
  if (isCarListing(listing)) {
    return (
      <CarProduct
        {...listing}
        key={listing.id}
        offerId={offerId}
        position={position}
        rudderParentProductCode={rudderParentProductCode}
      />
    )
  }
  return (
    <HotelProduct
      {...listing}
      key={listing.hotelId}
      offerId={offerId}
      position={position}
      offerToken={offerToken}
      rudderParentProductCode={rudderParentProductCode}
    />
  )
}

export function renderXSellProducts(
  listings: Listing[],
  numProducts = 2,
  offerId: string,
  offerToken: string,
  rudderParentProductCode: RudderProductDesc
) {
  return listings
    .slice(0, numProducts)
    .map((listing, index) =>
      renderXSellProduct(
        listing,
        index + 1,
        offerId,
        offerToken,
        rudderParentProductCode
      )
    )
}
